module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_iter-step.js
// module id = 1518
// module chunks = 0